export type AttachmentDownloadStatus = "idle" | "downloading" | "error";

export function nextDownloadStatusOnStart(
  current: AttachmentDownloadStatus,
): AttachmentDownloadStatus | null {
  if (current === "downloading") {
    return null;
  }
  return "downloading";
}

export function nextDownloadStatusOnSuccess(): AttachmentDownloadStatus {
  return "idle";
}

export function nextDownloadStatusOnError(): AttachmentDownloadStatus {
  return "error";
}

export function downloadButtonDisabled(status: AttachmentDownloadStatus): boolean {
  return status === "downloading";
}

export function downloadActionI18nKey(status: AttachmentDownloadStatus): 
  | "inbox.media.preview.download"
  | "inbox.media.preview.downloading"
  | "inbox.media.preview.downloadFailed" {
  switch (status) {
    case "downloading":
      return "inbox.media.preview.downloading";
    case "error":
      return "inbox.media.preview.downloadFailed";
    case "idle":
      return "inbox.media.preview.download";
    default: {
      const _exhaustive: never = status;
      return _exhaustive;
    }
  }
}
